// extracted by mini-css-extract-plugin
export var formContainer = "_gd-0";
export var message = "_gd-1";